import { get } from 'lodash'

export default function () {
  /** Unidade Selecionada */
  if (get(this.$route, 'params.tower_id', null) !== null) {
    this.getTowersDweller()

    this.selectUnitsTower(get(this.$route, 'params.tower_id', null))
  }

  this.getTowersDweller()
}



// WEBPACK FOOTER //
// ./src/app/dweller/livings/form/resources/mounted.js